(function () {
  function initMegaMenu(wrapper) {
    const top = wrapper.querySelector('.mm-top');
    const links = wrapper.querySelectorAll('.mm-item.mm-has-panel > .mm-link');
    const panels = wrapper.querySelectorAll('.mm-panel');
    if (!top || !links.length) return;

    const behavior = top.dataset.behavior || 'hover';
    const mqDesktop = window.matchMedia('(pointer:fine) and (min-width: 990px)');
    let openPanelId = null;

    // Stagger helper: sets increasing animation delays
    function applyStagger(panel) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const items = panel.querySelectorAll('.mm-col, .mm-list li, .mm-icons .mm-icon');
      let delay = 120;         // first item delay (ms)
      const step = 70;        // gap between items (ms)
      items.forEach(el => {
        // reset to restart animation if panel reopens
        el.style.animation = 'none';
        el.offsetHeight; // reflow
        el.style.animation = '';
        el.style.animationDelay = delay + 'ms';
        delay += step;
      });
    }

    const open = (panelId) => {
      panels.forEach(p => {
        const visible = p.id === panelId;
        p.hidden = !visible;
        p.classList.toggle('is-visible', visible); // triggers CSS animations
        if (visible) {
          applyStagger(p);
        } else {
          // clear any delays when closing
          p.querySelectorAll('.mm-col, .mm-list li, .mm-icons .mm-icon').forEach(el => {
            el.style.animationDelay = '';
          });
        }
      });

      wrapper.classList.add('is-open');
      links.forEach(a => {
        const isThis = a.getAttribute('data-panel-id') === panelId;
        a.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
      openPanelId = panelId;
    };

    const closeAll = () => {
      panels.forEach(p => {
        p.hidden = true;
        p.classList.remove('is-visible');
      });
      wrapper.classList.remove('is-open');
      links.forEach(a => a.setAttribute('aria-expanded', 'false'));
      openPanelId = null;
    };

    // Open/close behavior
    links.forEach(link => {
      const id = link.getAttribute('data-panel-id');
      if (mqDesktop.matches && behavior === 'hover') {
        link.addEventListener('mouseenter', () => open(id));
        link.addEventListener('focus', () => open(id));
      }
      link.addEventListener('click', (e) => {
        const useHover = mqDesktop.matches && behavior === 'hover';
        const alreadyOpen = openPanelId === id;
        if (useHover) {
          if (!alreadyOpen) {
            e.preventDefault();
            open(id);
          }
        } else {
          e.preventDefault();
          alreadyOpen ? closeAll() : open(id);
        }
      });
    });

    if (mqDesktop.matches && behavior === 'hover') {
      wrapper.addEventListener('mouseleave', () => closeAll());
    }

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) closeAll();
    });

    wrapper.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mm-wrapper').forEach(initMegaMenu);
  });
})();